import './modal-challenge-status.scss';
import ModalTemplate from '../modal-template/modal-template';
import ChallengeStatus from '../challenge-status/challenge-status'

export default function ModalChallengeStatus(props) {

    return (
        <ModalTemplate isOpen={props.isOpen} className={'modal-challenge-status ' + ( props.data && props.data.status === 'won' ? 'won': '')}>
            {props.data && <ChallengeStatus {...props} /> }
        </ModalTemplate>
    )
}